module.exports = __webpack_public_path__ + "img/disableImg.a36d9e75.png";